import moment from 'moment';

const CalendarsAdapter = data => {
  if (!data) {
    return [];
  }

  const newArr = [];

  const prepareData = (i) => ({
    ...i,
    week_day: moment(i.calendar_date).week(),
    day: moment(i.calendar_date).format('dddd'),
    day_type: i.day_type_title,
    type_close: i.type_close_title,
    'footfalls.visitors': i.footfall,
    'analytics_calendar_categories.title': i.analytics_calendar_category,
  });

  if (Array.isArray(data)) {
    data.forEach(i => {
      newArr.push(prepareData(i));
    });

    return newArr;
  }

  return prepareData(data);
};

export default CalendarsAdapter;
